import { gql } from '@apollo/client';

import { interactiveLessonSectionComponentFragment } from 'approot/activity-builder/lesson-builder.graphql';

export const DELETE_ACTIVITIES_COLUMNS = gql`
  mutation DeleteActivitiesColumns($input: DeleteActivitiesColumnsInput!) {
    deleteActivitiesColumns(input: $input) {
      ...InteractiveLessonSectionComponent
    }
  }
  ${interactiveLessonSectionComponentFragment}
`;
